var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mapContainer"},[_c('div',{staticStyle:{"display":"none"}},[(_vm.initialized)?_vm._t("default"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }